var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/redux-form@6.8.0_btckld2a72haxcqt7vtk4t56yu/~/redux-form/es/util/getDisplayName.js
// module id = 681
// module chunks = 0